import type { ContentType, SortByOption } from '@kimuno/api-sdk';

import type { pageContentTypes } from '../constants';

export type PageContentType = (typeof pageContentTypes)[number]['key'];

export interface SearchFilters {
	boost?: string;
	classYear?: string[];
	term?: string;
	publisher?: string[];
	subject?: string[];
	subTopic?: string[];
	minClassYear?: number;
	maxClassYear?: number;
	workload?: string[];
	teachingFormat?: string[];
	learningFormat?: string[];
	contentType?: ContentType[];
	pageContentType?: PageContentType[];
	schoolType?: string[];
	sortBy?: SortByOption;
	//courses
	courseTheme?: string[];
	courseType?: string[];
	courseDuration?: string[];
	inclusionAdapted?: boolean;
	teachingMethod?: string[];
}

export interface Pagination {
	total: number;
	limit: number;
	offset: number;
}

export interface BasicFilterProps<T> {
	updateFilter: (values: T) => void;
	clearFilter: () => void;
	currentValue?: T;
	onToggle?: () => void;
	onItemClick?: (item: string) => void;
}

export enum SearchResultsTab {
	MINDITEMS = 'arbeitsblaetter',
	PRODUCTS = 'ebooks',
	VIDEOS = 'videos',
	COURSES = 'courses',
	ALL = 'all',
}

export interface Subject {
	id: string;
	text: string;
}
